<template>
  <div>
    <div class="quote fs-14">
      <!-- Provider -->
      <div
        class="quote-element quote-element--logo pa-2"
        @click="onClickViewDetails(quote)"
      >
        <img
          :src="qd.imageSiteRemote"
          :alt="qd.brokerFullName"
          class="provider-logo"
        >
        <results-price
          v-if="isViewMonthly"
          :quote="quote"
          :monthly="!isViewMonthly"
          :selected-optional-extras="selectedOptionalExtras"
          size="small"
          class="info--text pt-2"
        />
      </div>

      <!-- Price -->
      <results-price
        :quote="quote"
        :monthly="isViewMonthly"
        :cashback="cashback"
        :selected-optional-extras="selectedOptionalExtras"
        class="quote-element quote-element--price pa-2"
        @open-drawer-details="$emit('open-drawer-details', ['details-description', 'estimatedPrice'])"
        @open-more-info="onClickViewDetails(quote)"
      />

      <!-- Policy details -->
      <div class="quote-element quote-element--info">
        <v-btn
          rounded
          :small="isViewMonthly"
          color="success"
          @click="onClickViewDetails(quote)"
        >
          <span>More</span>
        </v-btn>
      </div>
    </div>

    <!-- Optional extras -->
    <results-optional-extra-mobile
      :mobile-extras="mobileExtras"
      :extras="qd.optionalExtra"
    />
  </div>
</template>

<script>
import ResultsPrice from '@/components/car/Results/ResultsPrice.vue';
import ResultsOptionalExtraMobile from '@/components/travel/Results/ResultsOptionalExtraMobile.vue';
import { sortQuoteOptions } from '@/helpers/common';

export default {
  name: 'results-quote-mobile',
  components: {
    ResultsPrice,
    ResultsOptionalExtraMobile,
  },
  props: {
    quote: {
      type: Object,
      required: true,
    },
    isViewMonthly: {
      type: Boolean,
      required: true,
    },
    optionalExtrasColumns: {
      type: Array,
      required: true,
    },
    selectedOptionalExtras: {
      type: Array,
      required: true,
    },
  },
  computed: {
    qd () {
      return this.quote.details[0];
    },
    mobileExtras () {
      return this.optionalExtrasColumns.filter(this.showOptionalExtra).sort(this.sortMobileExtras);
    },
    cashback () {
      return +this.qd.cashback;
    },
  },
  methods: {
    onClickViewDetails (quote) {
      this.$emit('click-view-details', quote);
    },
    showOptionalExtra (optionalExtra) {
      return optionalExtra === 'maxExcess'
        ? false
        : this.qd.optionalExtra[optionalExtra].included !== 'N';
    },
    selectedOptionalExtra (optionalExtra) {
      return (this.selectedOptionalExtras.includes(optionalExtra) &&
        this.qd.optionalExtra[optionalExtra].cover !== null);
    },
    sortMobileExtras (keyOptionA, keyOptionB) {
      const oA = this.qd.optionalExtra[keyOptionA].included;
      const oB = this.qd.optionalExtra[keyOptionB].included;
      return sortQuoteOptions(oA, oB);
    },
  },
};
</script>

<style scoped lang="scss">
.quote {
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid $clr-heather;
  margin-left: 8px;
  margin-right: 8px;

  &-element {
    flex-shrink: 0;
    text-align: center;

    &--logo {
      flex-basis: 40%;
      width: 40%;
    }

    &--price,
    &--info {
      flex-basis: 30%;
      width: 30%;
    }

    &--price {
      border-left: 1px solid $clr-heather;
      border-right: 1px solid $clr-heather;
    }

    &--info {
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
}
</style>

<style scoped lang="scss" src='@/assets/scss/results/results-quote.scss' />
